import React from "react";

const MediumIcon = ({ children }) => {
  return React.cloneElement(children, { height: "20px", width: "20px" });
};

export default MediumIcon;
